import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18 12.8716C17.0182 13.2795 15.9413 13.5046 14.8119 13.5046C10.2188 13.5046 6.49539 9.78118 6.49539 5.18811C6.49539 4.05868 6.72053 2.98183 7.12839 2C4.11739 3.25076 2 6.21986 2 9.6835C2 14.2766 5.72342 18 10.3165 18C13.7801 18 16.7492 15.8826 18 12.8716Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.2288 7.03383C13.1782 6.91582 13.0842 6.82179 12.9662 6.77122L11.0723 5.95957C10.6683 5.78641 10.6683 5.21359 11.0723 5.04043L12.9662 4.22878C13.0842 4.17821 13.1782 4.08418 13.2288 3.96617L14.0404 2.07233C14.2136 1.66828 14.7864 1.66828 14.9596 2.07234L15.7712 3.96617C15.8218 4.08418 15.9158 4.17821 16.0338 4.22878L17.9277 5.04043C18.3317 5.21359 18.3317 5.78641 17.9277 5.95957L16.0338 6.77122C15.9158 6.82179 15.8218 6.91582 15.7712 7.03383L14.9596 8.92766C14.7864 9.33172 14.2136 9.33172 14.0404 8.92766L13.2288 7.03383Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }